<template>
  <EditorButton :title="$t('image')">
    <template v-slot:trigger="{ hide, show }">
      <MPopover
        ref="popover"
        placement="bottomRight"
        :overlay-style="{ width: '300px' }"
        @show="handleShowPopover"
      >
        <template v-slot:trigger>
          <MButton
            variant="transparent"
            class="small-icon-button"
            :shadow="false"
            @mouseenter="show"
            @mouseleave="hide"
          >
            <slot />
          </MButton>
        </template>
        <FlotoForm @submit="handleFormSubmit">
          <FlotoFormItem rules="required" :label="$t('image')">
            <FlotoAttachment
              v-model="image"
              as-link
              :use-public-api="usePublicApi"
              ignore-preference-validation
              :max-files="1"
              :button-text="`${$t('select')} ${$t('image')}`"
              :allowed-extensions="imageAllowedExtensions"
            />
          </FlotoFormItem>
          <template v-slot:submit>
            <div class="flex justify-end">
              <MButton type="submit" size="small" class="mx-1">
                {{ $t('add') }}
              </MButton>
              <MButton size="small" variant="default" @click="hideMenu">
                {{ $t('cancel') }}
              </MButton>
            </div>
          </template>
        </FlotoForm>
      </MPopover>
    </template>
  </EditorButton>
</template>

<script>
import { buildImageUrlFromRefFileName } from '@data/attachment'
import { PreferenceComputed } from '@state/modules/preference'
import EditorButton from './editor-button'
export default {
  name: 'LinkButton',
  components: { EditorButton },
  props: {
    usePublicApi: { type: Boolean, default: false },
    allowedExtensions: { type: Array, default: () => ['png', 'jpg', 'jpeg'] },
  },
  data() {
    return {
      image: [],
    }
  },
  computed: {
    ...PreferenceComputed,
    imageAllowedExtensions() {
      const preferenceFileExtensions = this.fileExtensionsNames || []
      const allowedFileExtensions = this.allowedExtensions || []
      if (this.fileExtensionMode === 'allow') {
        return allowedFileExtensions.filter((ext) =>
          preferenceFileExtensions.includes(ext.toLowerCase())
        )
      } else if (this.fileExtensionMode === 'block') {
        return allowedFileExtensions.filter(
          (ext) => !preferenceFileExtensions.includes(ext.toLowerCase())
        )
      }
      return allowedFileExtensions
    },
  },
  methods: {
    handleShowPopover() {
      this.image = []
    },
    handleFormSubmit() {
      this.$emit('add', buildImageUrlFromRefFileName(this.image[0].refFileName))
      this.hideMenu()
    },
    hideMenu() {
      this.$emit('hide')
      this.$refs.popover.hide()
    },
  },
}
</script>
